import React, { useEffect, useState } from "react";
import { Create, SimpleForm, TextInput, required, DateInput, AutocompleteInput, useRedirect, useNotify } from "react-admin";
import { getNameAndCompanyNamewithAddress } from "../common";
import { useLocation } from "react-router-dom";

const VisitHistoryCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const location = useLocation();
  const [customers,setCustomers] = useState([]);
  const searchParams = new URLSearchParams(location.search);
  const [customerId,setCustomerId]=useState(searchParams.get("customer"));
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <>
    {customers &&
      <Create mutationMode="pessimistic"      
          mutationOptions={{ 
          onSuccess: () => {
            notify('作成が完了しました', { type: 'success' }); 
            // redirect('list', 'visitHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            validate={required()}
            allowEmpty
            freeSolo  
            onChange={(e) => setCustomerId(e)}
            defaultValue={customerId}
          />
          <DateInput source="visitDate" label="訪問日" inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="content" label="訪問内容" multiline rows={5}/>
          <TextInput source="staffName" label="対応担当者"/>

        </SimpleForm>
      </Create>
    }
    </>
  )

};

export default VisitHistoryCreate;
